import './BadgeSelectField.scss'

import React from 'react'

import { Badge } from '../Badge'
import { FormField } from '../FormField'

/**
 * @typedef {Object} BadgeSelectOption
 * @property {number|string} value
 * @property {string} label
 * @property {Object} [analytics]
 */

/**
 * Badges to select multiple options.
 * @param {Object} props
 * @param {string} [props.className] Additional classes
 * @param {BadgeSelectOption[]} props.options Available options to select
 * @param {string} props.label
 * @param {Array<number|string>} props.value Current values
 * @param {string} props.name Name of the form element
 * @param {(value: number[], name: string) => void} props.onChange
 * @param {boolean} [props.noLabel]
 */
const BadgeSelectField = ({ className, options, label, value, name, onChange, noLabel }) => {
    const toggleValue = optionValue => e => {
        e.preventDefault()

        const newValue = []
        options.forEach(option => {
            const wasSelected = value.includes(option.value)
            if (
                (wasSelected && optionValue !== option.value) ||
                (!wasSelected && optionValue === option.value)
            ) {
                newValue.push(option.value)
            }
        })

        onChange(newValue, name)
    }

    const optionElements = []
    const badges = []
    options.forEach((option, i) => {
        optionElements.push(
            <option key={i} value={option.value} onSelect={toggleValue(option.value)}>
                {option.label}
            </option>
        )
        badges.push(
            <Badge
                key={i}
                variant={(value.includes(option.value)) ? 'primary' : null}
                onClick={toggleValue(option.value)}
                analytics={option.analytics}
            >
                {option.label}
            </Badge>
        )
    })

    const formFieldProps = { name, label, noLabel }

    let classes = 'badge-select-field'
    if (className) classes += ' ' + className

    return (
        <FormField {...formFieldProps} className={classes} renderElement={props => (
            <select multiple {...props} value={value.map(item => '' + item)} onChange={() => {}}>
                {optionElements}
            </select>
        )}>
            {badges}
        </FormField>
    )
}

export default BadgeSelectField
